import React, { useMemo } from 'react';
import { InView } from 'react-intersection-observer';

import Spinner from '@components/Spinner';
import useEventTracking from '@hooks/useEventTracking';
import useRecommendedReporters from '@hooks/useRecommendedReporters';
import { impression } from '@tracking';

import ReporterCard from './ReporterCard';
import ForYouSection from './Section';
import { FOR_YOU_ENGAGEMENT_LABELS, FOR_YOU_SECTION_IDS } from './constants';
import useRegisterSection from './useRegisterSection';

const ForYouReporters = () => {
  const { trackEvent } = useEventTracking();
  const { reporters, followsReporters, isLoadingReporters } = useRecommendedReporters();

  const reportersDisplayText = useMemo(() => {
    if (!reporters) return FOR_YOU_ENGAGEMENT_LABELS.NotEngaged.Reporters;

    return followsReporters
      ? FOR_YOU_ENGAGEMENT_LABELS.Engaged.Reporters
      : FOR_YOU_ENGAGEMENT_LABELS.NotEngaged.Reporters;
  }, [followsReporters, reporters]);

  useRegisterSection(FOR_YOU_SECTION_IDS.Reporters, isLoadingReporters || !!reporters?.length);

  if (!isLoadingReporters && !reporters?.length) return null;

  return (
    <ForYouSection
      id={FOR_YOU_SECTION_IDS.Reporters}
      highlight={reportersDisplayText.label}
      subtitle={reportersDisplayText.subtitle}
      title={reportersDisplayText.title}
    >
      <InView
        onChange={(inView) => {
          inView && trackEvent(impression({ impressionElement: FOR_YOU_SECTION_IDS.Reporters }));
        }}
        triggerOnce
      >
        <div className="flex flex-row flex-wrap gap-32 md:justify-between md:gap-64 *:md:max-w-[374px] lg:flex-nowrap">
          {!isLoadingReporters && reporters ? (
            reporters.map((reporter) => <ReporterCard key={reporter.id} reporter={reporter} />)
          ) : (
            <Spinner marginY="small" />
          )}
        </div>
      </InView>
    </ForYouSection>
  );
};

export default ForYouReporters;
